import { Button, useClipboard } from '@chakra-ui/react';

const CopyButton = ({ code, label = 'Copy code', ...props }) => {
  const { hasCopied, onCopy } = useClipboard(code);

  return (
    <Button
      size="sm"
      colorScheme="blue"
      {...props}
      onClick={onCopy}
    >
      {hasCopied ? 'Copied!' : label}
    </Button>
  );
};

export default CopyButton;
